import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { Product } from '../../../../../app/shared/models/b2b/product';
import { User } from '../../../../../app/shared/models/b2b/user';
import * as moment from 'moment';
import { SearchSettings } from '../../../../../app/shared/models/b2b/searchSettings';
import { SearchType } from '../../../../../app/shared/models/b2b/searchType';
import { Stock } from '../../../../../app/shared/models/b2b/stock';
import { Subscriber } from '../../helpers/subscriber';
import { AppState } from 'app/store';
import { Store } from '@ngrx/store';
import { ListType } from 'app/shared/models/b2b/filterTop';
import { SoledadProductService } from 'app/shared/services/b2b/product.service';
import { Cart } from 'app/shared/models/b2b/cart';
import { SoledadUserService } from 'app/shared/services/b2b/user.service';

@Component({
    selector: 'app-item-product',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './item-product.component.html',
})
export class ItemProductComponent extends Subscriber implements OnInit, OnChanges {
    SearchType = SearchType;
    currentListType: string;
    ListType = ListType;
    @Input() item: Product = null;
    @Input() featured = false;
    @Input() user: User;
    @Input() searchSettings: SearchSettings;
    @Input() searchType: SearchType;
    @Input() typeLabel: string;
    @Input() isNotified: boolean;
    @Input() productStock: Stock[];

    today: string = moment().format('YYYY-MM-DD');
    @Output() clickBuyProduct: EventEmitter<Product> = new EventEmitter<Product>();
    @Output() clickNotifyDisponibility: EventEmitter<Product> = new EventEmitter<Product>();
    @Output() clickProductStock: EventEmitter<any> = new EventEmitter();
    @Output() clickProductPrices: EventEmitter<Product> = new EventEmitter<Product>();
    @Output() clickProductRates: EventEmitter<Product> = new EventEmitter<Product>();
    @Output() clickProductUPVS: EventEmitter<Product> = new EventEmitter<Product>();
    @Output() clickExtendInfo: EventEmitter<{ ev: any; item: Product }> = new EventEmitter<{
        ev: any;
        item: Product;
    }>();
    @Output() clickCloseExtendInfo: EventEmitter<void> = new EventEmitter();

    extendInfoIsOpen = false;
    cart: Cart;
    constructor(
        private store: Store<AppState>,
        private productsService: SoledadProductService,
        private cdr: ChangeDetectorRef,
        public us: SoledadUserService
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscribeSettingSearch();
        this.subscribeCart();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.item) {
            this.item = { ...changes.item.currentValue };
            if (this.item.resultadosTipo) {
                this.item.resultadosTipo = this.item.resultadosTipo.map((resultado) => {
                    return {
                        ...resultado,
                        tooltipOpen: false,
                    };
                });
            }
        }
        if (changes && changes.featured) {
            this.featured = !!changes.featured.currentValue;
        }
        if (changes && changes.user) {
            this.user = changes.user.currentValue;
        }
        if (changes && changes.searchSettings) {
            this.searchSettings = changes.searchSettings.currentValue;
        }
        if (changes && changes.searchType) {
            this.searchType = changes.searchType.currentValue;
        }
        if (changes && changes.isNotified) {
            this.isNotified = changes.isNotified.currentValue;
        }
        if (changes && changes.productStock) {
            this.productStock = changes.productStock.currentValue;
        }
    }

    subscribeCart(): void {
        this.addSubscription(
            this.store
                .select((state) => state.cart.cart)
                .subscribe((data) => {
                    this.cart = { ...data };
                    this.cdr.detectChanges();
                })
        );
    }

    subscribeSettingSearch(): void {
        this.addSubscription(
            this.store
                .select((state) => state.filterTop.settings)
                .subscribe((data) => {
                    if (data) {
                        // console.log("subscribeSettingSearch: ", data);
                        this.searchSettings = data;

                        this.searchSettings.tipoResultadoBusqueda === 'AVANZADO'
                            ? (this.currentListType = ListType.big)
                            : (this.currentListType = ListType.small);

                        // this.setCurrentListType(this.currentListType);
                    }
                })
        );
    }

    isToday(date: string): boolean {
        return date === 'Hoy' || date === "Aujourd'hui" || date === 'Hoje';
    }

    isTomorrow(date: string): boolean {
        return date === 'Mañana' || date === 'Demain' || date === 'Manhã';
    }

    showBRateBuyButton(): boolean {
        return (
            this.item.rates.b.preArt !== null &&
            this.item.rates.base.precioMostrarBusqueda !== this.item.rates.b.precioMostrarBusqueda &&
            this.item.rates.c.preArt === null
        );
    }

    showCRateBuyButton(): boolean {
        return (
            this.item.rates.c.preArt !== null &&
            this.item.rates.base.precioMostrarBusqueda !== this.item.rates.c.precioMostrarBusqueda
        );
    }

    decreasePreSelectedUnits(ev: MouseEvent) {
        ev.stopPropagation();
        this.item = { ...this.item, preSelectedUnits: this.item.preSelectedUnits - this.item.cantMult };
    }

    increasePreSelectedUnits(ev: MouseEvent) {
        ev.stopPropagation();
        this.item = { ...this.item, preSelectedUnits: this.item.preSelectedUnits + this.item.cantMult };
    }

    onClickBuyProduct(event: MouseEvent) {
        event.stopPropagation();
        this.clickBuyProduct.emit(this.item);
    }

    onClickNotifyDisponibility(event: MouseEvent) {
        event.stopPropagation();
        this.clickNotifyDisponibility.emit(this.item);
    }

    onClickProductStock(id: string, user: User, modal: boolean, item: Product, event: Event) {
        event.stopPropagation();
        this.clickProductStock.emit({ id, user, modal, item, event });
    }

    onClickProductPrices(event: Event) {
        event.stopPropagation();
        this.clickProductPrices.emit(this.item);
    }

    onClickProductRates(event: Event) {
        event.stopPropagation();
        this.clickProductRates.emit(this.item);
    }

    onClickProductUPVS(event: Event) {
        event.stopPropagation();
        this.clickProductUPVS.emit(this.item);
    }

    onClickExtendInfo(ev: any, item: Product) {
        if (this.extendInfoIsOpen) {
            this.clickCloseExtendInfo.emit();
        } else {
            this.clickExtendInfo.emit({ ev, item });
        }
    }

    isBuyable(item: Product): boolean {
        return this.user.confirmarPedido && this.isOportunityBuyable(item);
    }

    isOportunityBuyable(item: Product): boolean {
        const maxReached = this.productsService.isOpportunitieBuyable(this.cart, item);
        return (
            this.searchType !== SearchType.oportunities ||
            (this.searchType === SearchType.oportunities && item.stockFull > 0 && !maxReached)
        );
    }

    onClickPromo(event: Event, resultado: any) {
        event.stopPropagation();
        if (resultado.burl) {
            window.open(resultado.burl, '_blank');
            return;
        }
        resultado.tooltipOpen = !resultado.tooltipOpen;
    }

    onErrorImage(event: Event) {
        (event.target as HTMLImageElement).style.visibility = 'hidden';
    }
}
